/**
 * Core / Mint / Methods: Sections
 * ------------------------------------------------------------------------------
 * - Export of shared methods between mint-components and mint-sections
 * - Mostly handles Pinia actions.
 *
 */
import CorePiniaActions from '~/core/mint/methods/core-pinia-actions'

/**
 * Export Section & Component methods.
 * @return {Object}
 */
export default () => {
  return {

    /**
     * Pinia actions.
     */
    ...CorePiniaActions(),

    /**
     * Set Event Bus Listeners.
     */
    setEventBusListeners() {

      /**
       * Screen has been resized.
       * - Event is emitted from mint-core and this event
       * ensures that Section components are kept in sync.
       */
      mint.EventBus.on('mint:resize', (response) => {
        this.setScreen(response.screen)
      })

      /**
       * A feature flag has been toggled.
       * - Event is emitted from mint-core and this event
       * ensures that Section components are kept in sync.
       */
      mint.EventBus.on('mint:toggle:flag', (flags) => {
        if (!Array.isArray(flags)) {
          return
        }

        flags.forEach((flag) => {
          this.toggleFeatureFlag(flag)
        })
      })

      /**
       * The Global-E locale has been set.
       * - Event is emitted from mint-core and this event
       * ensures that Section components are kept in sync.
       */
      mint.EventBus.on('mint:locale:set', (response) => {
        this.setLocale(response, true)
      })

      /**
       * The cart data has been updated.
       * - Event is emitted from Pinia/Cart
       * - This event ensures each different Vue instance are up-to-date.
       */
      mint.EventBus.on('mint:cart:updated', (response) => {
        this.setCart(response)
      })

      /**
       * The cart data has been updated.
       * - Event is emitted from Pinia/Cart
       * - This event ensures each different Vue instance are up-to-date.
       */
      mint.EventBus.on('mint:wishlist:updated', (response) => {
        this.setWishlist(response)
      })

      /**
       * The product object has been updated.
       * - Used on the PDP templates only.
       * - This event ensures each different Vue instance are up-to-date.
       */
      if (mint.request.pageType === 'product') {
        mint.EventBus.on('mint:product:updated', (response) => {
          const instanceId = response.instanceId
          this.setProduct({
            completeTheLook: response.completeTheLook,
            initialProduct: response.initialProduct,
            isSection: true,
            product: response.productData,
            variant: response.currentVariant,
            instanceId,
          })
        })
      }
    },
  }
}
